"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.State = exports.ImageMimeType = exports.LogoFileType = exports.MainNavigationCopyKey = exports.ApplicationConfigKey = void 0;
var ApplicationConfigKey;
(function (ApplicationConfigKey) {
    ApplicationConfigKey["clientConfig"] = "clientConfig";
    ApplicationConfigKey["clientOverrides"] = "clientOverrides";
    ApplicationConfigKey["logoConfigs"] = "logoConfigs";
    ApplicationConfigKey["mainNavigation"] = "mainNavigation";
    ApplicationConfigKey["dashboardSidebar"] = "dashboardSidebar";
    ApplicationConfigKey["mapWidgetQuestions"] = "BASE_MAP_WIDGET_QUESTIONS";
    ApplicationConfigKey["terms"] = "terms";
})(ApplicationConfigKey = exports.ApplicationConfigKey || (exports.ApplicationConfigKey = {}));
var MainNavigationCopyKey;
(function (MainNavigationCopyKey) {
    MainNavigationCopyKey["dashboard"] = "dashboard";
    MainNavigationCopyKey["documents"] = "documents";
    MainNavigationCopyKey["menu"] = "menu";
    MainNavigationCopyKey["profile"] = "profile";
    MainNavigationCopyKey["reports"] = "reports";
})(MainNavigationCopyKey = exports.MainNavigationCopyKey || (exports.MainNavigationCopyKey = {}));
var LogoFileType;
(function (LogoFileType) {
    LogoFileType["png"] = "image/png";
    LogoFileType["svg"] = "image/svg+xml";
})(LogoFileType = exports.LogoFileType || (exports.LogoFileType = {}));
var ImageMimeType;
(function (ImageMimeType) {
    ImageMimeType["jpg"] = "image/jpeg";
    ImageMimeType["png"] = "image/png";
    ImageMimeType["svg"] = "image/svg+xml";
})(ImageMimeType = exports.ImageMimeType || (exports.ImageMimeType = {}));
var State;
(function (State) {
    State["Alabama"] = "ALABAMA";
    State["Alaska"] = "ALASKA";
    State["Arizona"] = "ARIZONA";
    State["Arkansas"] = "ARKANSAS";
    State["California"] = "CALIFORNIA";
    State["Colorado"] = "COLORADO";
    State["Connecticut"] = "CONNECTICUT";
    State["Delaware"] = "DELEWARE";
    State["Florida"] = "FLORIDA";
    State["Georgia"] = "GEORGIA";
    State["Hawaii"] = "HAWAII";
    State["Idaho"] = "IDAHO";
    State["Illinois"] = "ILLINOIS";
    State["Indiana"] = "INDIANA";
    State["Iowa"] = "IOWA";
    State["Kansas"] = "KANSAS";
    State["Kentucky"] = "KENTUCKY";
    State["Louisiana"] = "LOUSIANA";
    State["Maine"] = "MAINE";
    State["Maryland"] = "MARYLAND";
    State["Massachusetts"] = "MASSACHUSETTS";
    State["Michigan"] = "MICHIGAN";
    State["Minnesota"] = "MINNESOTA";
    State["Mississippi"] = "MISSISSIPPI";
    State["Missouri"] = "MISSOURI";
    State["Montana"] = "MONTANA";
    State["Nebraska"] = "NEBRASKA";
    State["Nevada"] = "NEVADA";
    State["NewHampshire"] = "NEW HAMPSHIRE";
    State["NewJersey"] = "NEW JERSEY";
    State["NewMexico"] = "NEW MEXICO";
    State["NewYork"] = "NEW YORK";
    State["NorthCarolina"] = "NORTH CAROLINA";
    State["NorthDakota"] = "NORTH DAKOTA";
    State["Ohio"] = "OHIO";
    State["Oklahoma"] = "OKLAHOMA";
    State["Oregon"] = "OREGON";
    State["Pennsylvania"] = "PENNSYLVANIA";
    State["RhodeIsland"] = "RHODE ISLAND";
    State["SouthCarolina"] = "SOUTH CAROLINA";
    State["SouthDakota"] = "SOUTH DAKOTA";
    State["Tennessee"] = "TENNESSEE";
    State["Texas"] = "TEXAS";
    State["Utah"] = "UTAH";
    State["Vermont"] = "VERMONT";
    State["Virginia"] = "VIRGINIA";
    State["Washington"] = "WASHINGTON";
    State["WestVirginia"] = "WEST VIRGINIA";
    State["Wisconsin"] = "WISCONSIN";
    State["Wyoming"] = "WYOMING";
})(State = exports.State || (exports.State = {}));
//# sourceMappingURL=applicationConfigTypes.js.map